import * as React from 'react';
import { TrailingContentMenuItemDefinition } from './AmorgMenuTypes';
import { StyledToolTip } from './helpers/StyledTooltip';
import { BaseButton } from './helpers/BaseButton';
import { TrailingContent } from './contentTypes/TrailingContent';
import { PrimaryContent } from './contentTypes/PrimaryContent';
import { getFlex } from './helpers/flexHelper';


type PropsWithoutType = Omit<TrailingContentMenuItemDefinition, "type">;

export function TrailingContentMenuItem(props:PropsWithoutType)
    :JSX.Element
{
    const [isHovering, setIsHovering] = React.useState(false);

    const flexes = getFlex(props.primaryContent, props.trailingContent);

    return (
        <BaseButton 
            selected={props.selectedState || false}
            styleVariant={props.styleVariant}
            isHovering={props.onClick && isHovering}
            onClick={props.onClick} 
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)} >

            <div style={{display:'flex', justifyContent:'stretch', alignItems:'flexStart'}}>
                
                <PrimaryContent {...props.primaryContent} onClick={props.onClick} isHovering={isHovering} styleVariant={props.styleVariant} flex={flexes.primaryContentFlex} />

                <TrailingContent {...props.trailingContent} onClick={props.onClick} isHovering={isHovering} styleVariant={props.styleVariant} flex={flexes.trailingContentFlex} />

            </div>
            
            {/* should go into BaseButton */}
            {props.toolTip && isHovering &&
                <StyledToolTip>{props.toolTip}</StyledToolTip>
            }

        </BaseButton>
    );
}
